import axiosClient from '@/config/api/axios'
import { USAGE_ME } from '@/config/api/endpoints'
import { isApiConfigured } from '@/config/api/env'
import { usageSummarySchema } from '@/schemas/usage/usageSummary'
import { emptyUsageSummary } from './usageMappers'

export function isUsageApiAvailable() {
  return isApiConfigured()
}

/**
 * Token usage for the signed-in user.
 *
 * Falls back to an unconfigured summary rather than throwing so the settings
 * page renders without the API — same posture as `documentsApi`.
 *
 * @param {{ signal?: AbortSignal, granularity?: string }} [options]
 */
export async function fetchMyUsage(options = {}) {
  if (!isUsageApiAvailable()) return emptyUsageSummary()
  const { data } = await axiosClient.get(USAGE_ME, {
    params: { granularity: options.granularity ?? 'day' },
    signal: options.signal,
  })
  const parsed = usageSummarySchema.safeParse(data)
  return parsed.success ? parsed.data : emptyUsageSummary()
}
